// Single source of truth for app branding
export const brand = {
  name: "Owner2Agent",
  tagline: "Privacy-first property exchange",
  description: "Privacy-first property marketplace for South Africa",
  year: 2026,
} as const;
